import { createSlice } from "@reduxjs/toolkit";
import { FilterStateDivergenceList } from "./types";

const INITIAL_STATE: FilterStateDivergenceList = {
  filters: {
    search: "",
    meta: {
      page: 1,
      perPage: 10,
    },
  },
};

const divergenceListFilterSlice = createSlice({
  name: "divergenceListFilter",
  initialState: INITIAL_STATE,
  reducers: {
    setDivergenceListFilter(state, action) {
      state.filters[action.payload.key] = action.payload.value;
    },
  },
});

export const { setDivergenceListFilter } = divergenceListFilterSlice.actions;
export default divergenceListFilterSlice.reducer;
